import React from "react";
import { PROFILE } from "../../data/profile";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-white/[0.06] py-12 text-sm"
    >
      <div className="mx-auto max-w-7xl px-5 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <p className="font-serif text-2xl italic">{PROFILE.name}</p>
          <p className="mt-1 text-muted-foreground">
            Built with React, FastAPI & Qwen via Hugging Face · {new Date().getFullYear()}
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-3">
          <a
            href={PROFILE.source_site}
            target="_blank"
            rel="noreferrer"
            className="font-mono-ed text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground"
            data-testid="footer-source"
          >
            ↗ shivmuratgupta.com
          </a>
          <span className="text-muted-foreground/40">·</span>
          <a
            href={`mailto:${PROFILE.email}`}
            className="font-mono-ed text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground"
            data-testid="footer-email"
          >
            ↗ {PROFILE.email}
          </a>
        </div>
      </div>
    </footer>
  );
}
